<template>
  <v-snackbar
    v-model="showNotification"
    :timeout="4000"
    top
    right
    color="primary"
    elevation="6"
    rounded="lg"
    class="pwa-install-notification"
  >
    <div class="d-flex align-center">
      <v-icon left color="white" size="24">mdi-download</v-icon>
      <div class="notification-content">
        <div class="notification-title">Install {{ $appName }}</div>
        <div class="notification-subtitle">Add to your home screen for quick access</div>
      </div>
    </div>
    
    <!-- Arrow pointing to browser menu -->
    <div class="install-arrow" v-if="showArrow">
      <v-icon color="white" size="32">mdi-arrow-up-right</v-icon>
      <div class="arrow-text">Tap menu, then "Add to Home Screen"</div>
    </div>
    
    <template v-slot:action="{ attrs }">
      <v-btn
        text
        color="white"
        v-bind="attrs"
        @click="dismissNotification"
        small
      >
        Got it
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'PWAInstallNotification',
  data() {
    return {
      showNotification: false,
      showArrow: false,
    }
  },
  computed: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
    isStandalone() {
      // Check multiple ways to detect if app is running as PWA
      return window.matchMedia('(display-mode: standalone)').matches || 
             window.navigator.standalone === true ||
             document.referrer.includes('android-app://') ||
             window.matchMedia('(display-mode: fullscreen)').matches ||
             window.matchMedia('(display-mode: minimal-ui)').matches
    },
    shouldShowNotification() {
      // Show if mobile, not already installed, and hasn't been dismissed
      return this.isMobile && 
             !this.isStandalone && 
             !localStorage.getItem('pwa-install-dismissed')
    }
  },
  methods: {
    showInstallNotification() {
      if (this.shouldShowNotification) {
        // Small delay to let the dashboard load first
        setTimeout(() => {
          this.showNotification = true
          this.showArrow = true
          
          // Hide arrow after 2 seconds but keep notification
          setTimeout(() => {
            this.showArrow = false
          }, 2000)
        }, 1000)
      }
    },
    dismissNotification() {
      this.showNotification = false
      // Remember that user dismissed it
      localStorage.setItem('pwa-install-dismissed', 'true')
    }
  },
  mounted() {
    this.showInstallNotification()
  }
}
</script>

<style lang="scss" scoped>
.pwa-install-notification {
  z-index: 9999 !important;
  
  .v-snack__wrapper {
    min-width: 320px;
    max-width: 400px;
    z-index: 9999 !important;
  }
}

.notification-content {
  flex: 1;
  
  .notification-title {
    font-weight: 600;
    font-size: 16px;
    line-height: 1.2;
    color: white;
  }
  
  .notification-subtitle {
    font-size: 14px;
    opacity: 0.9;
    color: white;
    margin-top: 2px;
  }
}

.install-arrow {
  position: absolute;
  top: -45px;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: bounce 1s infinite;
  
  .arrow-text {
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    margin-top: 4px;
    position: relative;
    
    &::before {
      content: '';
      position: absolute;
      top: -4px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-bottom: 4px solid rgba(0, 0, 0, 0.8);
    }
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

@media (max-width: 600px) {
  .pwa-install-notification {
    .v-snack__wrapper {
      min-width: 280px;
      max-width: 320px;
    }
  }
  
  .notification-content {
    .notification-title {
      font-size: 15px;
    }
    
    .notification-subtitle {
      font-size: 13px;
    }
  }
  
  .install-arrow {
    right: 15px;
    
    .arrow-text {
      font-size: 11px;
      padding: 3px 6px;
    }
  }
}
</style>
